import classNames from 'classnames';
import React from 'react';

import { FormControl } from '@sravni/react-design-system';

import styles from './styles.module.scss';

interface Props {
  error?: string | boolean;
  message?: string;
  children: React.ReactElement<{ name?: string }>;
  className?: string;
}

export const Field: React.FC<Props> = ({ children, error, message, className }) => {
  return (
    <FormControl invalid={!!error} className={classNames(!error && !message && styles.control, className)}>
      {children}
      {(error || message) && <FormControl.HelperText>{error || message}</FormControl.HelperText>}
    </FormControl>
  );
};
